import React from 'react';
import PropTypes from 'prop-types';
import StandardKnob from './StandardKnob';
import Meter from './Meter';
import SongStore from '../stores/SongStore';

export default class MasterChannel extends React.Component {

	static contextTypes = {
		getStore: PropTypes.func.isRequired
	};

	constructor(props, context) {
		super(props, context);
		this.state = {
			channel: context.getStore(SongStore).getMasterChannel(),
			level: 0
		};

		context.getStore(SongStore).on("CHANNEL-MASTER-CHANGE", this.handleChange.bind(this));
	}

	handleChange() {
		this.setState({
			channel: this.context.getStore(SongStore).getMasterChannel()
		});
	}

	render() {
		return (
			<div className="Channel">
				<header>
					<p>Master</p>
				</header>
				<footer>
					<Meter low={175} high={200} max={255} number={7}/>
					<div className="controls">
						<StandardKnob param={this.state.channel.gain}/>
						<StandardKnob param={this.state.channel.pan}/>
					</div>
				</footer>
			</div>
		);
	}
}
